import { QueryClient } from '@tanstack/react-query';
import { PERSIST_MAX_AGE } from './persister';

/**
 * Shared TanStack Query client for the whole app.
 *
 * Caching defaults are intentionally generous: all data is published RSS
 * content refreshed by a daily 5 AM ingestion Cloud Function, so a query is
 * fresh for several minutes and there is no value in refetching on every
 * window focus.
 *
 * We use the core `@tanstack/react-query` only — no Firebase adapter — so
 * every query/mutation across the app shares one mental model (epic #101).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes — content changes at most daily
      // Match the persisted-cache max age (24h) so rehydrated entries are not
      // immediately garbage-collected on launch (offline support, #153).
      gcTime: PERSIST_MAX_AGE,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
